<template>
  <div>
    <div class="oasis-upload-list-item" v-for="file in fileList" :key="file">
      <div class="oasis-upload-list-item-info">
        <span>
          <a-icon type="paper-clip" class="file-icon" />
          <span class="oasis-upload-list-item-name">{{ file }}</span>
        </span>
      </div>
      <button class="close-button" @click="e => handleDelete(file)"></button>
      <a-icon type="close" class="close-icon" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    defaultList: Array,
  },
  data() {
    return {}
  },
  computed: {
    fileList() {
      return this.defaultList
    },
  },
  methods: {
    handleDelete(file) {
      this.$emit('delete', file)
    },
  },
}
</script>
<style lang="less" scoped>
.oasis-upload-list-item {
  margin-top: 8px;
  font-size: 14px;
  position: relative;
  height: 22px;
  .oasis-upload-list-item-info {
    height: 100%;
    padding: 0 12px 0 4px;
    transition: background-color 0.3s;
    span {
      display: block;
      line-height: 1.5;
      .file-icon {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
        position: absolute;
        top: 5px;
      }
      .oasis-upload-list-item-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-left: 22px;
        width: 100%;
        display: inline-block;
        text-decoration: none;
        line-height: 1.5;
      }
    }
  }
  .close-button {
    width: 1em;
    height: 1em;
    // visibility: hidden;
    position: absolute;
    top: 6px;
    right: 4px;
    z-index: 1;
    background: transparent;
    border: none;
    outline: none;
  }
  .close-icon {
    font-size: 12px;
    display: inline-block;
    transform: scale(0.83333333) rotate(0deg);
    transition: all 0.3s;
    opacity: 0;
    cursor: pointer;
    position: absolute;
    top: 6px;
    right: 4px;
    color: rgba(0, 0, 0, 0.45);
    line-height: 0;
  }
  &:hover {
    .oasis-upload-list-item-info {
      background-color: #e6f7ff;
    }
    .close-icon {
      opacity: 1;
    }
  }
}
</style>
